import {useAuth} from 'app/modules/auth'
import {CanteenMenu} from './CanteenMenu'
import {DphsMenu} from './DphsMenu'
import {DuaMenu} from './DuaMenu'
import {LecturerMenu} from './LecturerMenu'
import {SystemMenu} from './SystemMenu'
import {StudentMenu} from './StudentMenu'
import {SchoolLecturerMenu} from './SchoolLecturerMenu'
import {SchoolStudentMenu} from './SchoolStudentMenu'

export function MenuInner() {
  const system_id = localStorage.getItem('system_id')
  const sys = localStorage.getItem('system')
  const {currentUser} = useAuth()

  const pos = currentUser?.position

  const isAdmin =
    pos === 'Lecturer' || pos === 'Student' || pos === 'School Lecturer' || pos === 'School Student'

  return (
    <>
      {pos === 'Lecturer' && <LecturerMenu />}
      {pos === 'Student' && <StudentMenu />}
      {pos === 'School Lecturer' && <SchoolLecturerMenu />}
      {pos === 'School Student' && <SchoolStudentMenu />}

      {!isAdmin && (system_id === '1' || sys === 'System') && <SystemMenu />}
      {!isAdmin && (system_id === '2' || sys === 'University') && <DuaMenu />}
      {!isAdmin && (system_id === '3' || sys === 'School') && <DphsMenu />}
      {!isAdmin && (system_id === '5' || sys === 'Canteen') && <CanteenMenu />}
    </>
  )
}
